import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { swalError, swalInfo, swalSuccess } from '../../../shared/config/swalCommon';
import { ValueService, AdjudgedService, UserService, PaymentCapacityService, LogsService } from '../../../services/services.index';
import { Value, Withdrawal, User, Petition, PaymentCapacity, LogsNav } from '../../../interfaces/interfaces.index';
import { FGDesistirNominacion } from 'src/app/interfaces/forms/desistir-nominacion.interface';
import { Router } from '@angular/router';
import { nameMask} from '../../../shared/config/imaskCommon';

@Component({
  selector: 'app-desistir-nominacion',
  templateUrl: './desistir-nominacion.component.html',
  styleUrls: ['./desistir-nominacion.component.css'],
  styles: [`
    .example-form {min-width: 150px;max-width: 500px;width: 100%;}
    .example-full-width {width: 77%;}
  `]
})
export class DesistirNominacionComponent implements OnInit {
  loadValues: boolean;
  values: Value[] = [];
  mdn: Value[] = [];
  withdrawal: Withdrawal;
  userLogged: User;
  actualPetition: Petition;
  capacidad: PaymentCapacity;
  quota: string;
  fecha: string;
  paymentCapacity: PaymentCapacity;
  forma: FGDesistirNominacion;
  petition: Petition;
  formSubmitted = false;
  nameMask = nameMask;

  constructor(
    private fb: FormBuilder,
    private valueService: ValueService,
    private spinnerService: NgxSpinnerService,
    private adjudgedService: AdjudgedService,
    private userService: UserService,
    private paymentService: PaymentCapacityService,
    private router: Router,
    private logService: LogsService
  ) {
    this.userLogged = this.userService.user;
    this.getValues();
    this.forma = this.fb.group({
      otro_motivo: [null as string | null],
      observacion: [null as string | null],
      motivo: [null as string | null, Validators.required],
    });
    this.actualPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
    this.capacidad =  this.paymentService.getPaymentCapacityStore();
    if(this.capacidad !== undefined){
      this.quota = this.capacidad.quotaNumber.substring(0, 10);
      this.fecha = this.capacidad.date.toString();
      this.fecha = this.fecha.substring(0, 10);
      this.fecha = this.fecha.replace(/-/g, '');

    }

    this.petition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
  }

  ngOnInit(): void {
    this.addLogsNav();

    this.motivo.valueChanges.subscribe(x => {
      if(x === "25") {
        this.otro_motivo.setValidators(Validators.required);
        this.otro_motivo.updateValueAndValidity();
      }
      else {
        this.otro_motivo.setValue(null);
        this.otro_motivo.clearValidators();
        this.otro_motivo.updateValueAndValidity();
        this.observacion.setValue(null);
      }
    });
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  getValues = () => {
    this.loadValues = true;
    const types = ['motivos'];

    this.valueService.getValuesGroup(types).subscribe(data => {
      const buscar = (type: string) => this.values.filter(x => x.type === type);
      const ordenar = (values: Value[], orderName = true) => values.sort((a, b) => orderName ? a.name.localeCompare(b.name) : parseInt(a.valueId, 0) - parseInt(b.valueId, 0));
      this.values = data;
      this.mdn = ordenar(buscar('motivos'));
    }, error => this.handleError(error.error));
    this.loadValues = false;
  }

  handleError = (err) => { this.spinnerService.hide(); Swal.fire(swalError('Ha ocurrido un error', err.error?err.error.userMessage:err.userMessage)); };

  registrar = () => {
    this.formSubmitted = true;

    if(this.forma.invalid) {
      this.forma.markAllAsTouched();
      Swal.fire(swalInfo('Faltan campos requeridos, verifique'));
      this.formSubmitted = false;
      return;
    }

    this.spinnerService.show();
    this.adjudgedService.postWithdrawal(this.datosForm()).subscribe(async data => {
      this.spinnerService.hide();
      await Swal.fire(swalSuccess()).then(() => {
        if(this.actualPetition.processId === 3 || this.actualPetition.processId === 4)
          this.router.navigate([`proceso`]);
        else
          this.router.navigate([`solicitudes/inicio/usuario`]);
      });
    }, error => {
      this.formSubmitted = false;
      if(error.error?.userMessage === "Ya desistió adjudicación") {
        this.spinnerService.hide();
        Swal.fire({ title: "Recuerde", text: error.error?.userMessage, icon: 'info' });
      }
      else
        this.handleError(error.error);
    });
  }

  datosForm = (): Withdrawal => {
    if (this.withdrawal) {
    } else {
      this.withdrawal = {
        anotherReason: this.otro_motivo.value,
        observation: this.observacion.value,
        reasonId: String(this.motivo.value),
        petitionId: this.petition.id
      };
    }
    return this.withdrawal;

  }

  onBack() {
    if(this.petition.processStatus !== "Rejected") {
      if(this.petition.process == 3 || this.petition.process == 4)
        this.router.navigate([`proceso-capacidad-pago`, 1]);
      else
        this.router.navigate([`proceso-capacidad-pago`, 2]);
    }
    else {
      this.router.navigate(["opciones-capacidad-pago"]);
    }
  }

  get motivo() { return this.forma.get('motivo'); }
  get otro_motivo() { return this.forma.get('otro_motivo'); }
  get observacion()  { return this.forma.get('observacion'); }
}
